import { isTruthy } from '@ardoq/common-helpers';
import { ApiResponse } from './types';
import { fetchJson, Method, toRequestOptions } from './api';
import {
  CreateUrlOptions,
  NewSearchBody,
  NewSearchResponse,
  QuickSearchResult,
} from '@ardoq/api-types';

const createUrl = (
  query: string,
  { types, workspaceIds, customFieldName, from, size }: CreateUrlOptions
) => {
  return [
    `/api/search?q=${encodeURIComponent(query)}`,
    types && `&types=${types}`,
    workspaceIds && `&workspaceIds=${workspaceIds}`,
    customFieldName && `&customFieldName=${customFieldName}`,
    from && `&from=${from}`,
    size && `&size=${size}`,
  ]
    .filter(isTruthy)
    .join('');
};

const customSearch = (
  query: string,
  options: CreateUrlOptions
): ApiResponse<QuickSearchResult> => {
  const request = new Request(
    createUrl(query, options),
    toRequestOptions(Method.GET, undefined)
  );
  return fetchJson<QuickSearchResult>(request);
};

const newSearch = ({
  useSemantic,
  query,
  disableArdoqIdSearch,
  customSearchField,
  size,
  workspaceIds,
  filters,
}: NewSearchBody): ApiResponse<NewSearchResponse> => {
  const url = useSemantic
    ? `/api/semantic-search/search`
    : `/api/discover-component-search`;
  const request = new Request(
    url,
    toRequestOptions(Method.POST, {
      q: query, // Backward compatibility
      query,
      disableArdoqIdSearch,
      customSearchField,
      size,
      workspaceIds: workspaceIds ?? [],
      filters,
    })
  );
  return fetchJson<NewSearchResponse>(request);
};

export const searchApi = { customSearch, newSearch };
